import React, { FC, useState } from 'react'

import { getStyledElementProps } from '../../../utils/helpers'
import { Checkbox } from './../../atoms/checkbox/checkbox'

import styles from './widget-message-checkbox.module.scss'
import { WidgetMessageCheckboxProps } from './widget-message-checkbox.d'

export const WidgetMessageCheckbox: FC<WidgetMessageCheckboxProps> = ({
  label,
  name,
  multiple,
  onChange,
  onBlur,
  value = '',
  labelProps = {},
  checkboxProps = {},
  backgroundColor,
  checkColor,
}) => {
  const styledLabelProps = getStyledElementProps(labelProps, styles['label'])

  const [checked, setChecked] = useState(false)

  return (
    <label {...styledLabelProps}>
      <div
        className={styles['container-checkbox']}
        style={
          checked
            ? {
                backgroundColor: checkColor,
              }
            : {}
        }
      >
        <Checkbox
          name={name}
          value={value}
          multiple={multiple}
          checked={checked}
          onClick={() => setChecked(!checked)}
          onChange={onChange}
          onBlur={onBlur}
          {...checkboxProps}
          backgroundColor={backgroundColor}
          checkColor={checkColor}
          data-testid="widget-message-checkbox-test"
        />
      </div>
      <p
        data-testid="message-test"
        dangerouslySetInnerHTML={{
          __html: label,
        }}
        style={{ textAlign: 'left' }}
      ></p>
    </label>
  )
}
